export default "__VITE_ASSET__DP$VsQtq__"